// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BPvt","label":"styles_label__1jvgP"};